module.exports = __webpack_public_path__ + "static/media/sempreburrasca.2a230fff.jpeg";